import translations from '../translations/en.json';

export interface NavLink {
  id: string;
  label: string;
  href: string;
}

export const navLinks: NavLink[] = [
  { id: 'home', label: translations.common.home, href: '/' },
  { id: 'about', label: translations.common.about, href: 'https://skyporter.us/about' },
  { id: 'contact', label: translations.common.contact, href: 'https://skyporter.us/contact' },
  { id: 'faqs', label: translations.common.faqs, href: 'https://skyporter.us/faqs' },
];